import * as Types from '../types.generated'

import { gql } from '@apollo/client'
import { ConsortiumsListItemFragmentDoc } from './ConsortiumsListItem.generated'
import { OrganizationsListItemFragmentDoc } from './OrganizationsListItem.generated'
export const ConsortiumDetailsFragmentDoc = gql`
  fragment ConsortiumDetails on Consortium {
    ...ConsortiumsListItem
    socialUrls {
      type
      url
    }
    organizations {
      ...OrganizationsListItem
    }
  }
  ${ConsortiumsListItemFragmentDoc}
  ${OrganizationsListItemFragmentDoc}
`
export type ConsortiumDetailsFragment = {
  __typename?: 'Consortium'
  id: string
  name: string
  description: string
  slug: string
  socialUrls: Array<{ __typename?: 'SocialURL'; type: Types.SocialUrlType; url: string }>
  organizations: Array<{
    __typename?: 'Organization'
    id: string
    name: string
    description: string
    slug: string
    logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
  }>
  frameworks: Array<{ __typename?: 'BlockchainFramework'; name: string }>
  logo?: { __typename?: 'LogoInformation'; url: string; isBright: boolean } | null
}
